import { Outlet } from "react-router-dom";
import { Header } from "../components/header/Header";

export const RootLayout = () => {
  return (
    <section className="layout-wrapper">
      <Header />
      <Outlet />
    </section>
  );
};
